import Vue from "vue";

// 插件的包
import PerfectScrollbar from "perfect-scrollbar";
// 对应的css
import "perfect-scrollbar/css/perfect-scrollbar.css";

/**
 * 防止重复点击 2021-02-20 lzb 设置重复点击
 */
Vue.directive("limitRepeatClick", {
    inserted(el, binding) {
        const { value } = binding;
        const textContent = el.textContent;
        el.addEventListener("click", () => {
            if (!el.disabled) {
                el.disabled = true;
                setTimeout(() => {
                    el.disabled = false;
                }, value || 3000);
            }
        });
    },
});

/**
 * 指令判断是否只能输入数字
 */
Vue.directive("require-number", {
    inserted(el) {
        el.addEventListener("keypress", function (e) {
            e = e || window.event;
            const charcode = typeof e.charCode === "number" ? e.charCode : e.keyCode;
            const re = /\d/;
            if (!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey) {
                if (e.preventDefault) {
                    e.preventDefault();
                } else {
                    e.returnValue = false;
                }
            }
        });
    },
});

const el_scrollBar = (el) => {
    if (el._ps_ instanceof PerfectScrollbar) {
        el._ps_.update();
    } else {
        // 加属性
        el._ps_ = new PerfectScrollbar(el);
    }
};

/**
 * 滚动指令
 */
Vue.directive("scrollBar", {
    // inserted钩子函数，获取自定义指令处的dom
    inserted(el, binding, vnode) {
        // 为了配合element的table组件 在这里需要判断一下并给定类
        const { value } = binding;
        if (value === "elTable") {
            el = el.querySelector(".el-table__body-wrapper");
            if (!el) {
                return console.warn("未发现className为el-table__body-wrapper的dom");
            }
        }
        // 判断其样式是否存在position 并且position为"fixed", "absolute"或"relative"
        const rules = ["fixed", "absolute", "relative"];
        if (!rules.includes(window.getComputedStyle(el, null).position)) {
            console.error(`perfect-scrollbar所在的容器的position属性必须是以下之一：${rules.join("、")}`);
        }
        // el上挂一份属性
        el_scrollBar(el);
    },
    // 更新dom的时候
    componentUpdated(el, binding, vnode, oldVnode) {
        try {
            vnode.context.$nextTick(() => {
                el_scrollBar(el);
            });
        } catch (error) {
            console.log(error);
            el_scrollBar(el);
        }
    },
});

/**
 * 这个方法改一下， 能输入小数，但是最多能输入两位小数，
 * 如果输入1.236  返回1.23
 * 如果输入1.20 返回1.2
 * 如果输入1.0 返回1
 * 如果输入1.22 返回1.22
 * 如果输入1 返回1
 */
Vue.directive("positive-decimal", {
    inserted(el, binding) {
        // 获取 el-input-number 内部的 input 元素
        let input = el.querySelector("input");

        // 如果没有找到，说明可能直接是 input 元素
        if (!input) {
            input = el;
        }

        // 从指令绑定值获取 max，例如 v-positive-decimal="100"
        const max = binding.value != null ? Number(binding.value) : null;

        // 处理输入事件 - 实时限制小数位数和最大值
        input.addEventListener("input", function (e) {
            let value = this.value;

            // 如果为空，直接返回
            if (value === "" || value == 0) {
                return;
            }

            // 只允许数字和小数点
            value = value.replace(/[^\d.]/g, "");

            // 处理多个小数点的情况
            const parts = value.split(".");
            if (parts.length > 2) {
                value = parts[0] + "." + parts.slice(1).join("");
            }

            // 如果有小数点，限制小数位数为2位
            if (value.includes(".")) {
                const [integerPart, decimalPart] = value.split(".");
                if (decimalPart.length > 2) {
                    value = integerPart + "." + decimalPart.substring(0, 2);
                }
            }

            // 限制最大值
            if (max != null && value !== "" && value !== ".") {
                const num = parseFloat(value);
                if (!isNaN(num) && num > max) {
                    value = String(max);
                }
            }

            // 值有变化时更新并同步 v-model
            if (this.value !== value) {
                this.value = value;
                this.dispatchEvent(new Event("input", { bubbles: true }));
            }
        });

        // 处理失焦事件 - 格式化显示
        input.addEventListener("blur", function (e) {
            const self = this;
            const value = self.value;
            let finalValue = value;

            // 为空或0时回填最小值 1
            if (value === "" || value === "." || parseFloat(value) <= 0 || isNaN(parseFloat(value))) {
                finalValue = "1";
            } else {
                let num = parseFloat(value);

                // 限制最大值
                if (max != null && num > max) {
                    num = max;
                }

                // 保留两位小数，去掉末尾的0和小数点
                let rounded = Math.round(num * 100) / 100;
                let formatted = rounded.toString();
                if (formatted.includes(".")) {
                    formatted = formatted.replace(/\.?0+$/, "");
                }
                finalValue = formatted;
            }

            // 延迟执行，等 Vue 的 blur 处理完成后再强制覆盖
            setTimeout(() => {
                self.value = finalValue;
                self.dispatchEvent(new Event("input", { bubbles: true }));
                self.dispatchEvent(new Event("change", { bubbles: true }));
            }, 0);
        });
    },
});
